// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__2NHBC","title":"InfoRow_title__3K0gB"};